import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Body from './Body/Body';
import Assets from './home/assets'
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Assets />
  //<Body />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
